import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route, useLocation } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect } from "react";
import MainHome from "./Home/MainHome";
import Footer from "./CommonComponents/Footer";
import PreFooterForm from "./CommonComponents/PreFooterForm";
import Navbar from "./CommonComponents/Navbar";
import MainAbout from "./AboutUs/MainAbout";
import MainServices from "./Services/MainServices";
import MainContacts from "./Contacts/MainContacts";
import MainCandidateForm from "./CandidateForm/MainCandidateForm";
import MainClientForm from "./ClientForm/MainClientForm";
import CandidateFormView from "./CandidateForm/CandidateFormView";
import ClientFormView from "./ClientForm/ClientFormView";
import PreFooterFormView from "./CommonComponents/PreFooterFormView";
import ContactPageFormView from "./Contacts/ContactPageFormView";
import PrivacyPolicy from "./OtherPages/PrivacyPolicy";
import Terms from "./OtherPages/Terms";
import Agreements from "./OtherPages/Agreements";
import FloatingIcons from "./FloatingIcons/FloatingIcons";
import EndFooter from "./CommonComponents/EndFooter";
import PreNavbar from "./PreNavbar/PreNavbar";
import HelmetSEO from "./HelmetSEO/HelmetSEO";
import UserFeedback from "./Feedback/UserFeedback";
import AdminFeedBack from "./Feedback/AdminFeedBack";
import SEO from "./AASeo/Seo";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  const location = useLocation();

  return (
    <div className="App">
      <SEO
        title="SriMathi Manpower Consulting Services - Your Trusted Recruitment Partner"
        description="SriMathi Manpower Consulting Services is a leading recruitment agency dedicated to connecting top talent with premier employers. Explore our comprehensive staffing solutions today."
        keywords="recruitment, staffing, manpower, consulting"
        url={location.pathname}
      />
      <HelmetSEO page={location.pathname.replace("/", "") || "home"} />
      <ScrollToTop />
      <PreNavbar />
      <Navbar />
      <div className="content">
        <Routes>
          <Route path="/" element={<MainHome />} />
          <Route path="/home" element={<MainHome />} />
          <Route path="/aboutus" element={<MainAbout />} />
          <Route path="/ourservices" element={<MainServices />} />
          <Route path="/contactus" element={<MainContacts />} />
          <Route path="/clientform" element={<MainClientForm />} />
          <Route path="/candidateform" element={<MainCandidateForm />} />
          <Route path="/admincandidateform" element={<CandidateFormView />} />
          <Route path="/adminclientform" element={<ClientFormView />} />
          <Route path="/adminenquireform" element={<PreFooterFormView />} />
          <Route path="/admincontactus" element={<ContactPageFormView />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/agreements" element={<Agreements />} />
          <Route path="/userfeedback" element={<UserFeedback />} />
          <Route path="/smc/admin" element={<AdminFeedBack />} />
        </Routes>
      </div>
      <PreFooterForm />
      <EndFooter />
      <Footer />
      <FloatingIcons />
    </div>
  );
}

export default App;
